import base from "/home/ruri/github/monochrome/images/genius-active.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");